<template>
    <popper
        v-b-tooltip.hover.top
        title="Share"
        trigger="click"
        :options="{ placement: 'left' }"
    >
        <div class="popper text-left" style="max-width: 300px;" :data-test="'share-modal-' + shareType">
            <div class="popper-header"><h5>Share</h5></div>
            <form class="form" ref="form">
                <div class="form-group mb-3">
                    <label for="emailField">Email</label>
                    <input type="text" class="form-control" name="email" v-model="form.email" data-test="share-email-input" />
                    <form-errors :form="form" field="email.*"></form-errors>
                    <form-errors :form="form" field="email.0" rename="email"></form-errors>
                </div>
                <div class="form-group mb-3">
                    <label for="contentField">Message</label>
                    <textarea type="text" class="form-control" name="message" v-model="form.message"
                              placeholder="Message" rows="3" data-test="share-message-input"></textarea>
                    <form-errors :form="form" field="message"></form-errors>
                    <small tabindex="-1" class="form-text text-muted wrap">
                        If sharing more than 500 assets, your share will be limited to the first 500.
                    </small>
                </div>
                <div class="form-group mb-3">
                    <button class="btn btn-secondary" @click.prevent="submit" data-test="share-submit-button">
                        Submit
                    </button>
                    <button class="btn btn-cancel" @click.prevent="close" data-test="share-cancel-button">
                        Cancel
                    </button>
                </div>
            </form>
        </div>
        <button class="btn btn-icon" :class="buttonClass" slot="reference" :disabled="disable" :data-test="'share-button-' + shareType">
            <i class="fal fa-share-alt fa-fw"></i>
            <span class="sr-only">Share Order Item</span>
        </button>
    </popper>
</template>

<script>
import { Form, Query } from '@jgile/laravel-vue';

export default {
    props: {
        query: {
            required: false,
            default: null,
        },
        shareType: {
            required: true,
        },
        buttonClass: {
            type: String,
            default: null,
        },
        disable: {
            default: false,
        },
    },
    data() {
        return {
            form: new Form({
                email: null,
                message: null,
            }),
        };
    },
    methods: {
        close() {
            Bus.$emit('popperDoClose');
            this.$refs.form.reset();
        },
        submit() {
            const self = this;
            this.form.post(new Query(this.query).url(`/api/orders/share/${this.shareType}`)).then(() => {
                self.close();
            });
        },
    },
};
</script>
